import {
  Input,
  InputText,
  Textarea,
  Select,
  Radio,
} from '../index';
import { Panel } from '../../index';

import Date from '../date';
import Checkbox from '../checkbox';

const componentConfig = {
  // 日期选择器
  date: Date,
  // 文本输入框
  input: Input,
  // 段落输入框
  'input-text': InputText,
  // 多行输入
  textarea: Textarea,
  // 选择器
  select: Select,

  radio: Radio,

  checkbox: Checkbox,

  panel: Panel,

};

export default componentConfig;
